import { isCanonicalUuid } from "@/core/utils/uuid.utils";

export const VISITOR_ID_COOKIE = "rmd_visitor_id";

// Chrome caps cookie lifetime at 400 days; ask for the maximum so the ID survives
// as long as the browser allows.
export const VISITOR_ID_MAX_AGE_SECONDS = 400 * 24 * 60 * 60;

// Both mints (proxy and client) produce `crypto.randomUUID()`, which is always the
// canonical lowercase dashed form, and the backend VisitorId value object rejects
// anything else at the trust boundary. A cookie value outside this shape is foreign
// or corrupted and is re-minted rather than carried.
export function isCanonicalVisitorId(value: string): boolean {
  return isCanonicalUuid(value);
}
